import { Component, Prop, Vue } from 'vue-property-decorator'
import { AmplifyEventBus } from 'aws-amplify-vue'
import '@/styles/skin/app.scss'
import '@/styles/notification/style.scss'
import { EventBus } from './utils/eventbus'
import { PubSub, Auth } from 'aws-amplify'
import Observable from 'zen-observable'
import _ from 'lodash'

@Component
export default class App extends Vue {

  private pubsub: ZenObservable.Subscription

  private subConnect(id: string) {
    try {
      this.pubsub.unsubscribe()
    } catch { }

    this.pubsub = PubSub.subscribe(['topic/game-update-sync', `topic/private-sync/${id}`]).subscribe({
      next: (data: any) => {
        if (data.value.action === 'gameUpdate') {
          EventBus.$emit('boughtMatchups')
        }
        if (data.value.action === 'personalisedMatchupUpdate') {
          EventBus.$emit('boughtMatchups')
        }
        if (data.value.action === 'balanceUpdate') {
          this.$store.dispatch('GET_BALANCE')
        }
        if (data.value.action === 'historyUpdate') {
          this.$store.dispatch('GET_DRAFTS')
        }
      },
      error: (error: any) => { console.log(error) },
      complete: () => { console.log('complete ->') }
    });
  }

  private async created() {

    Auth.currentUserInfo().then( (res: object) => {
      if (_.has(res, 'id')) {
        //@ts-ignore
        this.subConnect(res.id)
      }
    })

    setInterval(() => {
      EventBus.$emit('globalTick')
    }, 60000)

    EventBus.$on('qpLogout', () => {
      if (this.pubsub) {
        this.pubsub.unsubscribe()
      }
      this.$router.push('signIn')
    })

    EventBus.$on('qpAuthenticated', (id: string) => {
      this.subConnect(id)
    })

    AmplifyEventBus.$on('localUser', (user: object) => {
      // @ts-ignore
      this.$store.dispatch('SET_VERIFYNAME', user.username)
    })

    AmplifyEventBus.$on('authState', (info: string) => {
      switch (info) {
        case 'signIn':
          this.$router.push('signIn')  
          break
        case 'signedIn':
            this.$router.push('home')  
          break
        case 'forgotPassword':
            this.$router.push('forgot')
          break
        case 'signUp':
          this.$router.push('signUp')
          break
        case 'confirmSignUp':
          this.$router.push('verify')
          break
      }
    })

    AmplifyEventBus.$on('signupErrorState', (info: string) => {
      //@ts-ignore
      heap.track('game:signup:errorstate', { message: info })
    })

    AmplifyEventBus.$on('signinErrorState', (info: string) => {
      //@ts-ignore
      heap.track('game:signin:errorstate', { message: info })
    })
  }

  private render(h: any) {
    return (
      <div id='app'>
        <router-view/>
      </div>
    );
  }
}
